import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_FATTURA_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeFatturaListAction,
} from '../../data.action';
import { filler } from '../../../../../utils/utils';

const retrieveFatturaListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_FATTURA_LIST),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_FATTURA_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ fatturaLoader: true })),
        of(setListConfigAction({ fattura: body })),
        defer(() =>
          from(
            request({
              path: `fattura/list`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return { total: p?.total, result: [...p?.result, ...filler] };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_FATTURA_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeFatturaListAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_FATTURA_LIST}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ fatturaLoader: false }))
      );
    })
  );

export default retrieveFatturaListEpic;
